import { getServiceName } from "constants/service/service"
import React, { useEffect } from "react"
import { ArrowRight } from "react-feather"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "store/store"

const DownloadDesktopAppIndex: React.FC = (props: any) => {
  const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0
  const isWindows = navigator.platform.toUpperCase().indexOf("WIN") >= 0

  const downloadDesktopApp = () => {
    if (isMac) {
      window.location.href = props.settings.macBrandDesktopAppDownloadUrl
    }

    if (isWindows) {
      window.location.href = props.settings.winBrandDesktopAppDownloadUrl
    }
  }

  return (
    <div className="flex flex-col items-center my-[100px] max-w-[620p] mx-auto">
      <div className="flex flex-col items-center">
        <p className="text-[48px] font-bold mb-[20px]">{getServiceName()} 프로그램을 설치해 주세요</p>
        <p className="text-center text-[16px] text-[#999999] mt-[20px]">
          쾌적한 환경에서 {getServiceName()} 관리자 기능을 이용하실 수 있습니다.
        </p>
        <div className="px-[28px] py-[20px] bg-black rounded-full mt-[30px] cursor-pointer flex flex-row items-center">
          <a onClick={downloadDesktopApp} className="text-white font-bold">
            {getServiceName()} 프로그램 다운로드
          </a>
          <img className="w-[12px] h-[12px] ml-[12px]" src="/assets/icons/ic-download-arrow-right-white.svg" />
        </div>

        <div className="w-full mt-[55px]">
          <img
            className="w-full"
            src="/assets/images/download-desktop-app/download-desktop-app.png"
            alt="download-desktop-app"
          />
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(DownloadDesktopAppIndex)
